import React from 'react';
import { Award, BookOpen, Users, Globe } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../context/LanguageContext';

const ASTROLOGER_PHOTO = '/media/founder/2_-_Copy.jpg';
const ASTROLOGER_PHOTO_2 = '/media/founder/IMG_9466-removebg-preview.png';

export default function About() {
  const { lang, t } = useLang();
  return (
    <section id="about" className="section-padding cosmic-bg relative overflow-hidden" data-testid="about-section">
      <div className="absolute top-0 right-0 w-96 h-96 bg-purple/10 rounded-full blur-[120px]" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gold/5 rounded-full blur-[100px]" />

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Photo */}
          <motion.div className="relative" data-testid="about-image-area"
            initial={{ opacity: 0, x: -40 }} whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <div className="relative z-10 rounded-[2rem] overflow-hidden glow-gold border border-gold/15">
              <div className="aspect-[4/5] relative">
                <img src={ASTROLOGER_PHOTO} alt="Vivek Mudgal" className="w-full h-full object-cover object-top" data-testid="astrologer-main-photo" />
                <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-center">
                  <p className="text-gold-gradient font-heading text-2xl font-medium">Vivek Mudgal</p>
                  <p className="text-text-muted text-xs tracking-wider uppercase mt-1">Astrologer | Vastu Expert | Cosmic Healer</p>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-36 h-36 rounded-2xl overflow-hidden border-2 border-surface shadow-xl z-20 hidden md:block glow-purple">
              <img src={ASTROLOGER_PHOTO_2} alt="Vivek Mudgal" className="w-full h-full object-cover object-top" data-testid="astrologer-secondary-photo" />
            </div>
            <div className="absolute -top-8 -left-8 w-32 h-32 border border-gold/15 rounded-[2rem]" />
          </motion.div>

          {/* Content */}
          <motion.div initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}>
            <p className="text-xs tracking-[0.3em] uppercase text-gold font-semibold font-body">{t('about.tag')}</p>
            <h2 className="font-heading text-4xl md:text-5xl font-medium text-text-main mt-4 mb-6 tracking-tight">
              {t('about.title1')} <span className="text-gold-gradient">{t('about.title2')}</span>
            </h2>
            <p className="text-text-muted leading-relaxed mb-4 text-lg">
              {t('about.desc')}
            </p>
            <div className="divine-divider my-8" />
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: Award, value: '15+', label: lang === 'hi' ? 'पुरस्कार' : 'Awards' },
                { icon: BookOpen, value: '5', label: lang === 'hi' ? 'पुस्तकें' : 'Books' },
                { icon: Users, value: '33K+', label: lang === 'hi' ? 'ग्राहक' : 'Clients' },
                { icon: Globe, value: '14+', label: lang === 'hi' ? 'देश' : 'Countries' },
              ].map((item, i) => (
                <div key={i} className="glass-card p-5 flex items-center gap-4" data-testid={`achievement-${i}`}>
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-gold/15 to-purple/15 flex items-center justify-center border border-gold/10">
                    <item.icon className="w-6 h-6 text-gold" />
                  </div>
                  <div>
                    <p className="font-heading text-2xl font-medium stat-number">{item.value}</p>
                    <p className="text-sm text-text-muted">{item.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
